if (!customElements.get('highlight-text-image')) {
  class HighLightTextImage extends HTMLElement {
    constructor() {
      super();

      this.sectionId = this.dataset.sectionId;
      this.section = this.closest(`.section-${this.sectionId}`);
      this.templates = this.section.querySelector("template").content.cloneNode(true);
      this.images = {};
      this.init();
    }

    connectedCallback() {
      
    }

    init() {
      let contentHTML = this.innerHTML;

      // Prepare image map from template blocks
      const images = this.templates.querySelectorAll('[data-id]');
      images.forEach((image) => {
        const key = image.dataset.id;
        this.images[key] = image;
      });

      // 1) Group tokens: wrap [grp]...[/grp] into non-breaking inline units
      // Use non-greedy match to avoid spanning across multiple groups
      contentHTML = contentHTML.replace(/\[grp\]([\s\S]*?)\[\/grp\]/g, '<span class="htwi-item">$1<\/span>');

      // 2) Prefix: wrap any leading text before the first group as a separate prefix line
      const firstGroupIndex = contentHTML.indexOf('<span class="htwi-item">');
      if (firstGroupIndex > 0) {
        const prefix = contentHTML.slice(0, firstGroupIndex);
        const rest = contentHTML.slice(firstGroupIndex);
        contentHTML = `<span class="htwi-prefix">${prefix}<\/span>${rest}`;
      }

      // 3) Line break tokens
      contentHTML = contentHTML
        // Universal line break
        .replace(/\[br\]/g, '<br>')
        // Viewport-specific line breaks
        .replace(/\[br:mobile\]/g, '<br class="htwi-br--mobile">')
        .replace(/\[br:desktop\]/g, '<br class="htwi-br--desktop">');

      // 4) Image tokens: replace [imgN] with corresponding template content
      contentHTML = contentHTML.replace(/\[img(\d+)\]/g, (match, p1) => {
        const imgIndex = `img${p1}`;
        const imageWrapper = this.images[imgIndex];
        if (imageWrapper) {
          return imageWrapper.innerHTML;
        }
        return match;
      });

      this.innerHTML = contentHTML;
    }
  }
  customElements.define('highlight-text-image', HighLightTextImage);
}
